(function () {
  var SLIDE_W = 96;
  var msliderState = new WeakMap();
  var qtyDocClickBound = false;

  function getRoot() {
    return document.querySelector('.cart-wrapper');
  }

  function cwRedirectHomeIfCartEmpty() {
    if (typeof customwearCartPage === 'undefined' || !customwearCartPage.homeUrl) {
      return;
    }
    var n = document.querySelectorAll('.woocommerce-cart-form .cart-item').length;
    if (n === 0) {
      window.location.href = customwearCartPage.homeUrl;
    }
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
      $(document.body).on('removed_from_cart', function () {
        window.setTimeout(cwRedirectHomeIfCartEmpty, 250);
      });
      $(document.body).on('updated_wc_div wc_fragments_refreshed', function () {
        bootCartPage();
      });
    });
  }

  function formatCartMoney(amount) {
    var n = Number(amount);
    if (!isFinite(n)) {
      return '';
    }
    return n.toFixed(2).replace('.', ',') + '\u00a0zł';
  }

  function parseMoneyText(text) {
    var raw = String(text || '')
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(',', '.');
    var val = parseFloat(raw);
    return isFinite(val) ? val : 0;
  }

  function updateLinePrice(wrap, qty) {
    var item = wrap.closest('.cart-item');
    if (!item) {
      return;
    }
    var unit = parseFloat(item.getAttribute('data-cw-unit-price') || '0');
    var priceEl = item.querySelector('.iprice');
    if (priceEl && unit > 0) {
      priceEl.textContent = formatCartMoney(unit * qty);
    }
    recalcCartTotalsPreview();
  }

  function recalcCartTotalsPreview() {
    var root = getRoot();
    if (!root) {
      return;
    }
    var sum = 0;
    root.querySelectorAll('.cart-item .iprice').forEach(function (el) {
      sum += parseMoneyText(el.textContent);
    });
    var formatted = formatCartMoney(sum);
    var subtotal = root.querySelector('.sum-row.cart-subtotal span:last-child');
    var total = root.querySelector('.sum-total-price, .sum-total .order-total span:last-child');
    if (subtotal) {
      subtotal.textContent = formatted;
    }
    if (total) {
      total.textContent = formatted;
    }
  }

  function requestFormSubmit(form) {
    var btn = document.getElementById('cw-update-cart');
    if (form.requestSubmit && btn) {
      form.requestSubmit(btn);
      return;
    }
    if (btn) {
      btn.click();
      return;
    }
    form.submit();
  }

  function replaceCartFromHtml(response) {
    if (typeof jQuery === 'undefined') {
      return false;
    }
    var $html = jQuery('<div>').append(jQuery.parseHTML(response, document, true));
    var $newForm = $html.find('.woocommerce-cart-form').first();
    var $newTotals = $html.find('.cart_totals').first();
    var $newCount = $html.find('.cart-wrapper [data-cw-cart-count]').first();

    if ($newForm.length) {
      jQuery('.woocommerce-cart-form').replaceWith($newForm);
    }
    if ($newTotals.length) {
      jQuery('.cart_totals').replaceWith($newTotals);
    }
    if ($newCount.length) {
      jQuery('.cart-wrapper [data-cw-cart-count]').replaceWith($newCount);
    }

    return $newForm.length > 0;
  }

  function submitCartUpdate() {
    var form = document.querySelector('.woocommerce-cart-form');
    if (!form) {
      return;
    }

    if (typeof jQuery !== 'undefined') {
      var $form = jQuery(form);
      if ($form.hasClass('processing')) {
        return;
      }
      $form.addClass('processing');
      if (jQuery.fn.block) {
        $form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
      }

      var data = $form.serialize();
      if (data.indexOf('update_cart') === -1) {
        data += (data ? '&' : '') + 'update_cart=Update+cart';
      }

      jQuery.ajax({
        type: form.getAttribute('method') || 'POST',
        url: form.getAttribute('action') || window.location.href,
        data: data,
        dataType: 'html',
        success: function (response) {
          if (!replaceCartFromHtml(response)) {
            requestFormSubmit(form);
            return;
          }
          jQuery(document.body).trigger('updated_wc_div');
          jQuery(document.body).trigger('wc_fragment_refresh');
          bootCartPage();
        },
        error: function () {
          requestFormSubmit(form);
        },
        complete: function () {
          $form.removeClass('processing');
          if (jQuery.fn.unblock) {
            $form.unblock();
          }
        }
      });
      return;
    }

    requestFormSubmit(form);
  }

  function parseGapPx(el) {
    try {
      var g = window.getComputedStyle(el).gap || '16px';
      var m = String(g).match(/([\d.]+)px/);
      if (m) {
        return parseFloat(m[1]);
      }
    } catch (e) {}
    return 16;
  }

  function getMsliderState(el) {
    if (!msliderState.has(el)) {
      msliderState.set(el, { index: 0 });
    }
    return msliderState.get(el);
  }

  function msliderSlideW(el) {
    var mvp = el.querySelector('.mvp');
    if (mvp && mvp.offsetWidth > 0) {
      return mvp.offsetWidth;
    }
    return SLIDE_W;
  }

  function setMsliderIndex(el, idx) {
    var track = el.querySelector('[data-cw-mslider-track]');
    var dots = el.querySelector('[data-cw-mslider-dots]');
    if (!track) {
      return;
    }
    var total = track.children.length;
    if (total < 1) {
      return;
    }
    var c = Math.max(0, Math.min(total - 1, idx));
    var st = getMsliderState(el);
    st.index = c;
    track.style.transform = 'translateX(-' + c * msliderSlideW(el) + 'px)';

    if (dots) {
      dots.querySelectorAll('.mdot').forEach(function (dot, i) {
        dot.classList.toggle('on', i === c);
      });
    }

    var prev = el.querySelector('[data-cw-mslider-prev]');
    var next = el.querySelector('[data-cw-mslider-next]');
    if (prev) {
      prev.disabled = c <= 0;
    }
    if (next) {
      next.disabled = c >= total - 1;
    }
  }

  function initMsliders(root) {
    root.querySelectorAll('[data-cw-cart-mslider]').forEach(function (el) {
      if (el.getAttribute('data-cw-mslider-ready') === '1') {
        return;
      }
      el.setAttribute('data-cw-mslider-ready', '1');
      setMsliderIndex(el, 0);

      el.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-cw-mslider-prev]')) {
          ev.preventDefault();
          ev.stopPropagation();
          setMsliderIndex(el, getMsliderState(el).index - 1);
          return;
        }
        if (ev.target.closest('[data-cw-mslider-next]')) {
          ev.preventDefault();
          ev.stopPropagation();
          setMsliderIndex(el, getMsliderState(el).index + 1);
          return;
        }
        var dot = ev.target.closest('[data-cw-mslider-dot]');
        if (dot) {
          ev.preventDefault();
          ev.stopPropagation();
          setMsliderIndex(el, Number(dot.getAttribute('data-cw-mslider-dot')) || 0);
        }
      });
    });
  }

  function closeAllQty(root) {
    root.querySelectorAll('[data-cw-qty-panel].open').forEach(function (p) {
      p.classList.remove('open');
    });
    root.querySelectorAll('[data-cw-qty-trig].open').forEach(function (t) {
      t.classList.remove('open');
      t.setAttribute('aria-expanded', 'false');
    });
  }

  function clampQty(val, max) {
    var v = parseInt(String(val), 10);
    if (isNaN(v) || v < 1) {
      v = 1;
    }
    if (max > 0 && v > max) {
      v = max;
    }
    return v;
  }

  function initQtyPanels(root) {
    root.querySelectorAll('[data-cw-cart-qty-wrap]').forEach(function (wrap) {
      if (wrap.getAttribute('data-cw-qty-ready') === '1') {
        return;
      }
      wrap.setAttribute('data-cw-qty-ready', '1');

      var trig = wrap.querySelector('[data-cw-qty-trig]');
      var panel = wrap.querySelector('[data-cw-qty-panel]');
      var input = wrap.querySelector('[data-cw-qty-input]');
      var hidden = wrap.querySelector('[data-cw-qty-hidden]');
      var display = wrap.querySelector('[data-cw-qty-display]');
      if (!trig || !panel || !input || !hidden) {
        return;
      }

      var max = parseInt(input.getAttribute('max'), 10) || 99;

      function syncDisplay(v) {
        if (display) {
          display.textContent = String(v);
        }
      }

      trig.addEventListener('click', function () {
        var isOpen = panel.classList.contains('open');
        closeAllQty(root);
        if (!isOpen) {
          panel.classList.add('open');
          trig.classList.add('open');
          trig.setAttribute('aria-expanded', 'true');
          input.value = hidden.value;
          syncDisplay(hidden.value);
        }
      });

      wrap.querySelectorAll('[data-cw-qty-minus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = clampQty((parseInt(input.value, 10) || 1) - 1, max);
          input.value = String(v);
          syncDisplay(v);
          updateLinePrice(wrap, v);
        });
      });

      wrap.querySelectorAll('[data-cw-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = clampQty((parseInt(input.value, 10) || 1) + 1, max);
          input.value = String(v);
          syncDisplay(v);
          updateLinePrice(wrap, v);
        });
      });

      input.addEventListener('input', function () {
        var v = clampQty(input.value, max);
        syncDisplay(v);
        updateLinePrice(wrap, v);
      });

      wrap.querySelectorAll('[data-cw-qty-confirm]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var prev = hidden.value;
          var v = clampQty(input.value, max);
          input.value = String(v);
          syncDisplay(v);
          closeAllQty(root);
          hidden.value = String(v);
          updateLinePrice(wrap, v);
          if (String(v) !== String(prev)) {
            submitCartUpdate();
          }
        });
      });
    });

    if (!qtyDocClickBound) {
      qtyDocClickBound = true;
      document.addEventListener('click', function (ev) {
        var r = getRoot();
        if (r && !ev.target.closest('[data-cw-cart-qty-wrap]')) {
          closeAllQty(r);
        }
      });
    }
  }

  function parseLbItems(source) {
    var raw = source.getAttribute('data-cw-lb-items');
    if (!raw) {
      return [];
    }
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function normalizeLbItems(items) {
    return items
      .map(function (item) {
        return {
          url: String(item.url || item.thumb || ''),
          label: String(item.label || ''),
          personalized: !!item.personalized
        };
      })
      .filter(function (item) {
        return item.url !== '';
      });
  }

  function lbOpen(items, startIndex) {
    var normalized = normalizeLbItems(items);
    if (!normalized.length) {
      return;
    }
    var start = Math.max(0, Math.min(normalized.length - 1, startIndex || 0));
    var lb = window.CustomWearProductLightbox;
    if (lb && typeof lb.open === 'function') {
      lb.open(normalized, start);
      return;
    }
    window.open(normalized[start].url, '_blank', 'noopener');
  }

  function initLightbox(root) {
    if (root.getAttribute('data-cw-lb-ready') === '1') {
      return;
    }
    root.setAttribute('data-cw-lb-ready', '1');

    root.addEventListener('click', function (ev) {
      var openBtn = ev.target.closest('[data-cw-cart-lb-open]');
      if (!openBtn || !root.contains(openBtn)) {
        return;
      }
      if (ev.target.closest('[data-cw-mslider-prev], [data-cw-mslider-next], [data-cw-mslider-dot]')) {
        return;
      }
      ev.preventDefault();

      var items = parseLbItems(openBtn);
      if (!items.length) {
        var parentSlider = openBtn.closest('[data-cw-cart-mslider]');
        if (parentSlider) {
          items = parseLbItems(parentSlider);
        }
      }
      if (!items.length) {
        return;
      }

      var start = 0;
      var slider = openBtn.closest('[data-cw-cart-mslider]');
      if (slider) {
        start = getMsliderState(slider).index;
      }
      lbOpen(items, start);
    });

    root.addEventListener('keydown', function (ev) {
      var openBtn = ev.target.closest('[data-cw-cart-lb-open]');
      if (!openBtn || (ev.key !== 'Enter' && ev.key !== ' ')) {
        return;
      }
      ev.preventDefault();
      openBtn.click();
    });
  }

  function initCoupon(root) {
    var couponSection = root.querySelector('.coup-section--invalid, .coupon-section--invalid');
    if (!couponSection || couponSection.getAttribute('data-cw-coupon-ready') === '1') {
      return;
    }
    couponSection.setAttribute('data-cw-coupon-ready', '1');
    var couponInput = couponSection.querySelector('#coupon_code');
    if (!couponInput) {
      return;
    }
    var defPh = couponInput.getAttribute('data-placeholder-default') || '';

    function clearCouponInvalidUi() {
      couponSection.classList.remove('coup-section--invalid', 'coupon-section--invalid');
      couponInput.placeholder = defPh;
      couponInput.removeAttribute('aria-invalid');
    }

    couponInput.addEventListener('focus', clearCouponInvalidUi, { once: true });
    couponInput.addEventListener('input', clearCouponInvalidUi, { once: true });
  }

  function initCartReco(root) {
    var sections = root.querySelectorAll('.cw-cart-reco');
    if (!sections.length) {
      return;
    }

    for (var i = 0; i < sections.length; i += 1) {
      (function (section) {
        if (section.getAttribute('data-cw-reco-ready') === '1') {
          return;
        }
        section.setAttribute('data-cw-reco-ready', '1');

        var viewport = section.querySelector('[data-reco-viewport]');
        var track = section.querySelector('[data-reco-track]');
        var btnBack = section.querySelector('.cw-cart-reco__arrow--back');
        var btnFwd = section.querySelector('.cw-cart-reco__arrow--forward');
        if (!viewport || !track) {
          return;
        }

        function itemStep() {
          var firstItem = track.querySelector('.cw-product-card');
          if (!firstItem) {
            return 280;
          }
          return firstItem.offsetWidth + parseGapPx(track);
        }

        function syncThumbArrowHeight() {
          var thumb = track.querySelector('.cw-product-card__media-wrap');
          var h = thumb ? thumb.offsetHeight : 0;
          if (h < 48) {
            h = 160;
          }
          if (btnBack) {
            btnBack.style.height = h + 'px';
          }
          if (btnFwd) {
            btnFwd.style.height = h + 'px';
          }
        }

        function onScroll() {
          var max = track.scrollWidth - track.clientWidth;
          var x = track.scrollLeft;

          if (x > 3) {
            viewport.classList.add('cw-cart-reco__viewport--bleed');
          } else {
            viewport.classList.remove('cw-cart-reco__viewport--bleed');
          }

          if (btnBack) {
            if (x > 3) {
              btnBack.removeAttribute('hidden');
            } else {
              btnBack.setAttribute('hidden', '');
            }
          }

          if (btnFwd) {
            if (max > 3 && x < max - 3) {
              btnFwd.removeAttribute('hidden');
            } else {
              btnFwd.setAttribute('hidden', '');
            }
          }
        }

        function bindArrows() {
          var arrows = section.querySelectorAll('[data-reco-arrow]');
          for (var j = 0; j < arrows.length; j += 1) {
            arrows[j].addEventListener('click', function () {
              var dir = Number(this.getAttribute('data-reco-arrow')) || 1;
              track.scrollBy({ left: itemStep() * dir, behavior: 'smooth' });
            });
          }
        }

        track.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', function () {
          syncThumbArrowHeight();
          onScroll();
        });

        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(function () {
            syncThumbArrowHeight();
            onScroll();
          });
          ro.observe(track);
        }

        bindArrows();
        syncThumbArrowHeight();
        onScroll();
        window.requestAnimationFrame(function () {
          syncThumbArrowHeight();
          onScroll();
        });
        window.addEventListener('load', function () {
          syncThumbArrowHeight();
          onScroll();
        });
      })(sections[i]);
    }
  }

  function bootCartPage() {
    var root = getRoot();
    if (!root) {
      return;
    }

    initMsliders(root);
    initQtyPanels(root);
    initLightbox(root);
    initCoupon(root);
    initCartReco(root);

    if (window.CustomWearProductCard && typeof window.CustomWearProductCard.init === 'function') {
      window.CustomWearProductCard.init(root);
    }
  }

  window.addEventListener('resize', function () {
    var root = getRoot();
    if (root) {
      root.querySelectorAll('[data-cw-cart-mslider]').forEach(function (el) {
        setMsliderIndex(el, getMsliderState(el).index);
      });
    }
  });

  bootCartPage();
})();
